import { DOCUMENT, Inject, Injectable } from '@angular/core';
import { Location } from '@angular/common';
import { HttpEvent, HttpHandler, HttpRequest } from '@angular/common/http';
import {
  MSAL_INTERCEPTOR_CONFIG,
  MsalBroadcastService,
  MsalInterceptor,
  MsalInterceptorConfiguration,
  MsalService,
} from '@azure/msal-angular';
import { Observable, defer } from 'rxjs';
import { resolveAccountForTenant } from './account-selection.util';
import { SESSION_STORAGE_KEYS } from '../session_storage/constants/session-storage-keys.constant';

/** Keep MSAL's endpoint/scopes/redirect behavior, but select the account before it captures it. */
@Injectable()
export class PortalMsalInterceptor extends MsalInterceptor {
  constructor(
    @Inject(MSAL_INTERCEPTOR_CONFIG) config: MsalInterceptorConfiguration,
    private readonly portalMsal: MsalService,
    location: Location,
    broadcast: MsalBroadcastService,
    @Inject(DOCUMENT) document: Document,
  ) {
    super(config, portalMsal, location, broadcast, document);
  }

  override intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return defer(() => {
      const instance = this.portalMsal.instance;
      const active = instance.getActiveAccount();
      const selected = resolveAccountForTenant(
        instance.getAllAccounts(),
        active,
        localStorage.getItem(SESSION_STORAGE_KEYS.TENANT_ID),
      );
      if (selected && (selected.tenantId !== active?.tenantId || selected.homeAccountId !== active?.homeAccountId)) {
        instance.setActiveAccount(selected);
      }
      // MSAL spreads its captured account over authRequest.account during acquireTokenSilent.
      // The factory rejects a missing explicit profile only for protected requests;
      // public assets must remain available even while sign-in is required.
      return super.intercept(request, next);
    });
  }
}
